import { GetServerSideProps } from 'next';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import OurTeamComponent from '../../components/OurTeam/OurTeamComponent';
import { apiRequest } from '../../components/util/requests/requests';
import { PageMetadata } from '../../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';
import { ImageProps } from '../../components/Models/MediaProps';

export interface Profile {
    name: string;
    role?: string;
    linkedInProfile?: string;
    image?: ImageProps;
}

export interface ProfileProps {
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const pageMetadata = await apiRequest(
        '/meta-pages?filters[key]=MANAGEMENT_TEAM_PAGE&populate[0]=seo'
    );

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
        },
    };
};

const ManagementTeam = ({ pageMetadata }: ProfileProps) => {
    return (
        <Layout seoMetadata={pageMetadata?.seo} defaultMetaTitle={'Noria.no - Management Team'}>
            <OurTeamComponent />
        </Layout>
    );
};

export default ManagementTeam;
